import { createAction, props } from '@ngrx/store';
import { SupportIssue } from './model';

export const loadIssuesComplete = createAction('[Support] loadIssuesComplete', props<{ issues: SupportIssue[] }>());
export const updateIssue = createAction('[Support] updateIssue', props<SupportIssue>());
export const markIssueAsRead = createAction('[Support] markIssueAsRead', props<{ issueId: string }>());
